<ng-container *transloco="let t">
  <div class="p-1">

    <div class="flex flex-row items-center gap-1 mb-2">
      <span cdkDragHandle class="flex items-center cursor-move">
        <i class="iconify text-lg opacity-60" data-icon="mdi:drag"></i>
      </span>
      <span class="flex-1 text-sm font-medium truncate">{{ field?.label }}</span>

      <button mat-icon-button [matMenuTriggerFor]="menu">
        <i class="iconify scale-80! opacity-80" data-icon="mdi:dots-vertical"></i>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openDialog()">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:add-square-outline"></i>
            <span>{{ t('Add') }}</span>
          </div>
        </button>

        @if (hasItems) {
        <button mat-menu-item (click)="selectAll()">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:checklist-minimalistic-outline"></i>
            <span>{{ t('Select all') }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="deselectAll()">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:stop-outline"></i>
            <span>{{ t('Deselect all') }}</span>
          </div>
        </button>
        }

        <button mat-menu-item (click)="clearItems()">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:eraser-linear"></i>
            <span>{{ t('Remove items') }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="removed.emit()">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:trash-bin-2-outline"></i>
            <span>{{ t('Remove filter') }}</span>
          </div>
        </button>
      </mat-menu>
    </div>

    @if (!hasItems) {
    <div class="flex items-center gap-2 border border-border rounded-xl pl-4 pr-2 h-10 cursor-pointer border-hover"
      (click)="openDialog()">
      <span class="flex-1 text-sm">{{ t('Select') }}</span>
      <i class="iconify text-xl opacity-80" data-icon="solar:square-arrow-right-up-broken"></i>
    </div>
    } @else {
    <div class="border border-border rounded-xl overflow-hidden py-1">
      <!-- <div class="max-h-64 overflow-y-auto pr-1"> -->
      <ng-scrollbar class="relative flex-1 max-h-50! min-h-0" visibility="hover" appearance="compact">
        @for (item of items; track item.id ?? item.code ?? $index) {
        <div class="flex items-center gap-2 pl-1 pr-4 py-0 " [matTooltip]="item.name"
              matTooltipPosition="right" [matTooltipShowDelay]="500" >
          <mat-checkbox [checked]="!!item.selected" (change)="toggleItem($index)"
            [disabled]="disabled()"></mat-checkbox>
          <span class="flex-1 text-sm  cursor-pointer leading-4" (click)="toggleItem($index)">{{ item.name }}</span>
          @if (allowRemoveItem) {
          <button type="button" (click)="removeItem($index)" [disabled]="disabled()"
            class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full p-1 transition-colors">
            <i class="iconify text-lg opacity-60 hover:opacity-100" data-icon="mdi:close"></i>
          </button>
          }
          @else if(item.color) {
          <div class="rounded-full w-1 h-4 opacity-70" [style.background-color]="item.color"> </div>
          }

        </div>
        }
      </ng-scrollbar>
      <!-- </div> -->
    </div>
    }

  </div>
</ng-container>
